<div
  class="icon-picker-container grid grid-cols-6 gap-2 p-2"
  [style.max-height]="maxHeight()"
>
  @for (icon of icons(); track icon) {
    @defer (on viewport) {
      <button
        mat-icon-button
        class="icon-sm !h-6 !w-6"
        [attr.data-icon]="icon"
        [class.!bg-primary-50]="isSelected(icon)"
        (click)="selectIcon(icon)"
      >
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    } @placeholder (minimum 150ms) {
      <ngx-skeleton-loader animation="pulse" count="5" />
    }
  }
</div>
